import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductService } from '../product.service';
import { Observable } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { Product } from '../product';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  products$: Observable<Product[]> | undefined;
  page = 0;

  constructor(
    private readonly route: ActivatedRoute,
    public readonly productService: ProductService,
    protected readonly googleAnalytics: GoogleAnalyticsService
  ) {}

  ngOnInit(): void {
    this.products$ = this.route.queryParams.pipe(
      tap((params) =>
        this.googleAnalytics.gtag('event', 'search', {
          search_term: params['query'],
        })
      ),
      mergeMap((params) => this.productService.search(params['query']))
    );
  }
}
